import type { ProductLogoMediumProps } from "../types";

/**
 * 中サイズのUserAccountsロゴアイコン
 */
export function ProductLogoMediumUserAccounts({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.95238" fill="#1A2142" />
      <path
        d="M12.1431 28.5715C12.1431 25.81 14.3817 23.5715 17.1431 23.5715H22.8574C25.6188 23.5715 27.8574 25.81 27.8574 28.5715H12.1431Z"
        fill="#57D7D9"
      />
      <path
        d="M13.5717 28.5715C13.5717 29.7549 14.5311 30.7143 15.7146 30.7143H24.286C25.4695 30.7143 26.4288 29.7549 26.4288 28.5715H13.5717Z"
        fill="#57D7D9"
      />
      <path
        d="M24.286 17.8572C24.286 20.2241 22.3672 22.1429 20.0003 22.1429C17.6333 22.1429 15.7146 20.2241 15.7146 17.8572C15.7146 15.4902 17.6333 13.5715 20.0003 13.5715C22.3672 13.5715 24.286 15.4902 24.286 17.8572Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0003 30.7143C25.9176 30.7143 30.7146 25.9174 30.7146 20C30.7146 14.0827 25.9176 9.28575 20.0003 9.28575C14.0829 9.28575 9.28599 14.0827 9.28599 20C9.28599 25.9174 14.0829 30.7143 20.0003 30.7143ZM20.0003 32.1429C26.7066 32.1429 32.1431 26.7063 32.1431 20C32.1431 13.2937 26.7066 7.85718 20.0003 7.85718C13.294 7.85718 7.85742 13.2937 7.85742 20C7.85742 26.7063 13.294 32.1429 20.0003 32.1429Z"
        fill="#FCFCFD"
      />
    </svg>
  );
}
